import type { LocalePack } from "./types";

const perks = [
  {
    title: "Sans caution",
    text: "Aucune caution ni carte de crédit exigée : paiement par carte de débit, espèces (EUR/RON) ou virement bancaire.",
  },
  {
    title: "Assurance complète incluse",
    text: "RCA et CASCO, vignette roumaine (rovinieta) et kilométrage illimité sont compris dans chaque location.",
  },
  {
    title: "Prise en charge 24h/24",
    text: "Remise des clés possible à toute heure, y compris la nuit, à l'aéroport ou à notre agence de Bucarest.",
  },
  {
    title: "Support WhatsApp direct",
    text: "Une question avant, pendant ou après la location ? Notre équipe répond en temps réel au +40738792499.",
  },
];

export const fr: LocalePack = {
  code: "fr",
  htmlLang: "fr",
  dir: "ltr",
  ui: {
    label: "Français",
    nav: {
      country: "Roumanie",
      airports: "Aéroports",
      cities: "Villes",
      guides: "Guides de voyage",
    },
    bookCta: "Réserver maintenant",
    fleetCta: "Voir la flotte",
    whatsappCta: "Écrire sur WhatsApp",
    fleetTitle: "Notre flotte de 28 véhicules",
    fleetSubtitle: "Des citadines économiques aux monospaces 7 places, un véhicule pour chaque besoin.",
    faqTitle: "Questions fréquentes",
    mapTitle: "Où nous trouver",
    relatedTitle: "Pages qui pourraient vous intéresser",
    priceNote: "Prix à partir de 35 €/jour, assurance et kilométrage illimité inclus.",
    breadcrumbHome: "Accueil",
  },
  pages: {
    country: {
      slug: "",
      title: "Location voiture Roumanie dès 35€/jour | carentals.ro",
      description: "Location voiture Roumanie sans caution, assurance RCA+CASCO et vignette incluses. Prise en charge à Bucarest ou à l'aéroport Otopeni. Devis WhatsApp.",
      eyebrow: "Location voiture en Roumanie",
      h1: "Location voiture Roumanie : simple, sans caution, sans surprise",
      intro: "carentals.ro loue des voitures à Bucarest et dans toute la Roumanie depuis notre agence du Boulevard Regina Elisabeta 33. Avec 28 véhicules disponibles, une assurance complète incluse et aucune carte de crédit exigée, réserver une voiture en Roumanie n'a jamais été aussi simple.",
      perks,
      sections: [
        {
          h2: "Pourquoi louer une voiture pour visiter la Roumanie",
          body: [
            "La Roumanie est un pays vaste, entre Carpates, littoral de la mer Noire et villes historiques comme Brasov ou Sibiu, difficile à explorer sans véhicule personnel. Une voiture de location vous permet de composer votre propre itinéraire, sans dépendre des horaires de train ou de bus.",
            "Chez carentals.ro, chaque location inclut le kilométrage illimité, l'assurance RCA et CASCO ainsi que la vignette routière obligatoire (rovinieta), pour rouler l'esprit tranquille sur les routes nationales et autoroutes roumaines.",
          ],
        },
        {
          h2: "Prise en charge à Bucarest ou à l'aéroport",
          body: [
            "La prise en charge est gratuite à notre agence de Bucarest ainsi qu'à l'aéroport international Henri Coanda (Otopeni). Pour toute autre adresse dans Bucarest, la livraison coûte 20 €.",
            "Pour une prise en charge dans une autre ville (Cluj, Iasi, Timisoara, Sibiu, Brasov, Constanta...), la livraison depuis Bucarest s'organise sur demande via WhatsApp, avec un devis personnalisé selon la distance.",
          ],
        },
        {
          h2: "Paiement simple, sans caution",
          body: [
            "Aucune carte de crédit n'est nécessaire : le paiement s'effectue par carte de débit, en espèces (euros ou lei roumains) ou par virement bancaire, et aucune caution n'est bloquée sur votre compte.",
            "Cette politique sans caution rend la location accessible à tous les voyageurs, y compris ceux qui ne possèdent pas de carte de crédit internationale, tout en gardant des tarifs à partir de 35 €/jour.",
          ],
        },
      ],
      faqs: [
        { q: "Faut-il une carte de crédit pour louer une voiture en Roumanie ?", a: "Non, aucune carte de crédit ni caution n'est requise chez carentals.ro. Le paiement se fait par carte de débit, espèces ou virement." },
        { q: "L'assurance est-elle incluse ?", a: "Oui, toutes nos locations incluent l'assurance RCA et CASCO, ainsi que la vignette roumaine et le kilométrage illimité." },
        { q: "Puis-je récupérer la voiture à l'aéroport de Bucarest ?", a: "Oui, la prise en charge est gratuite à l'aéroport Henri Coanda (Otopeni) ainsi qu'à notre agence du centre de Bucarest." },
        { q: "Comment réserver ou poser une question rapidement ?", a: "Le plus simple est de nous écrire directement sur WhatsApp au +40738792499, nous répondons rapidement 24h/24." },
      ],
      keywords: "location voiture roumanie, location voiture bucarest, louer une voiture en roumanie",
    },

    "airport-otopeni": {
      slug: "location-voiture-aeroport-bucarest-otopeni",
      title: "Location voiture aéroport Bucarest Otopeni | carentals.ro",
      description: "Location voiture à l'aéroport Otopeni (OTP), Bucarest. Prise en charge gratuite 24h/24, sans caution, assurance incluse. Réservez via WhatsApp.",
      eyebrow: "Aéroport Henri Coanda - Otopeni",
      h1: "Location voiture aéroport Bucarest Otopeni (OTP)",
      intro: "Atterrissage à Bucarest et besoin d'une voiture immédiatement ? carentals.ro propose la remise des clés gratuite directement à l'aéroport Henri Coanda (Otopeni), à toute heure du jour ou de la nuit, sans caution ni carte de crédit.",
      perks: [
        { title: "Remise des clés à l'aéroport", text: "Notre équipe vous accueille directement au terminal d'arrivées d'Otopeni, sans frais supplémentaires." },
        { title: "Disponible 24h/24", text: "Vol de nuit ou tôt le matin, la prise en charge à l'aéroport est possible à toute heure sur réservation." },
        { title: "Départ rapide", text: "Formalités simplifiées : en 10 minutes, vous prenez la route vers Bucarest ou les Carpates." },
        { title: "Restitution flexible", text: "Rendez le véhicule à l'aéroport avant votre vol retour, sans stress ni file d'attente." },
      ],
      sections: [
        {
          h2: "Comment ça se passe à l'arrivée à Otopeni",
          body: [
            "Dès votre atterrissage à l'aéroport Henri Coanda, il vous suffit de nous prévenir sur WhatsApp au +40738792499 : un membre de notre équipe vous rejoint au point de rendez-vous convenu avec le véhicule prêt à démarrer.",
            "Aucun comptoir à chercher dans le terminal, aucune file d'attente interminable : la remise des clés se fait en direct, avec vérification rapide du contrat et de la voiture.",
          ],
        },
        {
          h2: "Une location sans caution dès l'aéroport",
          body: [
            "Comme pour toutes nos locations, aucune carte de crédit ni caution n'est demandée à l'aéroport Otopeni. Vous payez par carte de débit, en espèces ou par virement bancaire.",
            "L'assurance RCA et CASCO, la vignette et le kilométrage illimité sont inclus dès la sortie de l'aéroport, pour prendre la route vers Bucarest ou plus loin en toute sérénité.",
          ],
        },
        {
          h2: "Vers Bucarest ou au-delà",
          body: [
            "L'aéroport Otopeni se trouve à environ 30 minutes du centre de Bucarest : idéal pour rejoindre rapidement votre hôtel ou démarrer un road trip vers Brasov, Sibiu ou la mer Noire.",
            "Besoin de rendre le véhicule dans une autre ville roumaine ? Contactez-nous par WhatsApp pour organiser une restitution one-way avec devis personnalisé.",
          ],
        },
      ],
      faqs: [
        { q: "Où récupère-t-on la voiture à l'aéroport Otopeni ?", a: "Directement à un point de rendez-vous proche des arrivées ; les coordonnées exactes vous sont envoyées après réservation." },
        { q: "La prise en charge de nuit est-elle possible ?", a: "Oui, notre service fonctionne 24h/24, y compris pour les vols de nuit ou très tôt le matin." },
        { q: "Y a-t-il des frais supplémentaires pour l'aéroport ?", a: "Non, la prise en charge à l'aéroport Otopeni est totalement gratuite." },
        { q: "Puis-je rendre la voiture à l'aéroport avant mon vol retour ?", a: "Oui, indiquez simplement l'heure de votre vol lors de la réservation pour organiser la restitution." },
      ],
      keywords: "location voiture aeroport bucarest, location voiture otopeni, location voiture aeroport henri coanda",
    },

    "airport-cluj": {
      slug: "location-voiture-aeroport-cluj",
      title: "Location voiture aéroport Cluj (CLJ) | carentals.ro",
      description: "Location voiture à l'aéroport de Cluj-Napoca. Livraison depuis Bucarest sur devis, sans caution, assurance et vignette incluses.",
      eyebrow: "Aéroport de Cluj-Napoca",
      h1: "Location voiture aéroport de Cluj (CLJ)",
      intro: "Vous atterrissez à Cluj-Napoca et souhaitez explorer la Transylvanie en voiture ? carentals.ro organise la livraison de son véhicule depuis Bucarest jusqu'à l'aéroport de Cluj, avec les mêmes conditions sans caution que dans notre agence.",
      perks,
      sections: [
        {
          h2: "Louer une voiture à Cluj depuis Bucarest",
          body: [
            "Notre flotte est basée à Bucarest, mais nous organisons régulièrement des livraisons vers l'aéroport de Cluj (CLJ) pour les voyageurs souhaitant sillonner la Transylvanie sans repasser par la capitale.",
            "Contactez-nous sur WhatsApp avant votre voyage avec vos dates de vol : nous établissons un devis incluant le transport du véhicule jusqu'à Cluj et, si besoin, une restitution ailleurs.",
          ],
        },
        {
          h2: "Explorer la Transylvanie depuis Cluj",
          body: [
            "Cluj-Napoca est un excellent point de départ pour rejoindre les châteaux de Transylvanie, les Carpates et les villages saxons, tous facilement accessibles en voiture.",
            "Chaque véhicule livré à Cluj inclut assurance RCA/CASCO, vignette et kilométrage illimité, comme pour toute location au départ de Bucarest.",
          ],
        },
        {
          h2: "Organiser une location one-way",
          body: [
            "Vous pouvez récupérer la voiture à Cluj et la restituer à Bucarest, à l'aéroport Otopeni ou dans une autre ville : ce type de location one-way est possible sur devis.",
            "Plus vous réservez tôt, plus nous pouvons organiser facilement la logistique de livraison et vous garantir le véhicule souhaité.",
          ],
        },
      ],
      faqs: [
        { q: "Peut-on louer une voiture directement à l'aéroport de Cluj ?", a: "Le véhicule est livré depuis Bucarest jusqu'à Cluj sur demande, avec un devis personnalisé selon vos dates." },
        { q: "Le kilométrage illimité s'applique-t-il aussi à Cluj ?", a: "Oui, toutes nos locations, y compris avec livraison à Cluj, incluent le kilométrage illimité." },
        { q: "Combien de temps à l'avance dois-je réserver ?", a: "Nous recommandons de réserver au moins une semaine à l'avance pour organiser la livraison à Cluj." },
        { q: "Puis-je restituer la voiture ailleurs qu'à Cluj ?", a: "Oui, une restitution dans une autre ville est possible, contactez-nous sur WhatsApp pour un devis one-way." },
      ],
      keywords: "location voiture cluj, location voiture aeroport cluj napoca, voiture transylvanie",
    },

    "airport-iasi": {
      slug: "location-voiture-aeroport-iasi",
      title: "Location voiture aéroport Iasi (IAS) | carentals.ro",
      description: "Location voiture à l'aéroport d'Iasi, livraison depuis Bucarest sur devis. Sans caution, assurance RCA+CASCO et vignette incluses.",
      eyebrow: "Aéroport d'Iasi",
      h1: "Location voiture aéroport d'Iasi (IAS)",
      intro: "Pour découvrir la Moldavie roumaine et ses monastères peints, carentals.ro peut livrer un véhicule jusqu'à l'aéroport d'Iasi, en toute transparence sur les délais et les coûts de transport depuis Bucarest.",
      perks,
      sections: [
        {
          h2: "Location voiture à Iasi, livrée depuis Bucarest",
          body: [
            "Notre agence est basée à Bucarest, mais nous livrons régulièrement des véhicules jusqu'à l'aéroport d'Iasi pour les voyageurs souhaitant explorer le nord-est de la Roumanie.",
            "Un devis clair vous est communiqué sur WhatsApp avant réservation, incluant le coût de la livraison longue distance et les conditions de restitution.",
          ],
        },
        {
          h2: "Découvrir les monastères de Moldavie",
          body: [
            "Iasi est la porte d'entrée idéale vers les monastères peints de Bucovine, classés au patrimoine de l'UNESCO, ainsi que vers les paysages vallonnés de Moldavie.",
            "Avec un kilométrage illimité inclus, vous pouvez multiplier les excursions sans vous soucier des kilomètres parcourus.",
          ],
        },
        {
          h2: "Conditions identiques à Bucarest",
          body: [
            "Même livré à Iasi, votre véhicule bénéficie de l'assurance RCA et CASCO, de la vignette roumaine et d'aucune caution exigée au départ.",
            "Le paiement reste flexible : carte de débit, espèces en euros ou lei, ou virement bancaire.",
          ],
        },
      ],
      faqs: [
        { q: "Livrez-vous des voitures jusqu'à Iasi ?", a: "Oui, sur demande via WhatsApp, avec un devis selon la distance depuis Bucarest." },
        { q: "Faut-il une caution pour une livraison à Iasi ?", a: "Non, aucune caution n'est exigée, comme pour toutes nos locations." },
        { q: "Peut-on faire une location one-way depuis Iasi ?", a: "Oui, restitution possible dans une autre ville sur devis personnalisé." },
        { q: "Le prix inclut-il l'assurance ?", a: "Oui, RCA, CASCO, vignette et kilométrage illimité sont toujours inclus." },
      ],
      keywords: "location voiture iasi, location voiture aeroport iasi, voiture moldavie roumanie",
    },

    "airport-timisoara": {
      slug: "location-voiture-aeroport-timisoara",
      title: "Location voiture aéroport Timisoara (TSR) | carentals.ro",
      description: "Location voiture à l'aéroport de Timisoara. Livraison depuis Bucarest sur devis, sans caution, assurance et vignette incluses.",
      eyebrow: "Aéroport de Timisoara",
      h1: "Location voiture aéroport de Timisoara (TSR)",
      intro: "Envie de découvrir le Banat et l'ouest de la Roumanie depuis Timisoara ? carentals.ro organise la livraison d'un véhicule depuis Bucarest jusqu'à l'aéroport de Timisoara, avec devis transparent.",
      perks,
      sections: [
        {
          h2: "Louer une voiture à Timisoara",
          body: [
            "Bien que notre agence soit basée à Bucarest, nous proposons la livraison de véhicules jusqu'à l'aéroport de Timisoara pour les voyageurs arrivant dans l'ouest du pays.",
            "Chaque livraison longue distance fait l'objet d'un devis sur mesure, communiqué avant confirmation de réservation via WhatsApp.",
          ],
        },
        {
          h2: "Explorer le Banat en voiture",
          body: [
            "Timisoara est un excellent point de départ pour visiter les gorges du Nera, le parc national de Semenic ou les villages colorés du Banat.",
            "Kilométrage illimité, assurance complète et vignette incluse vous permettent de parcourir la région sans contrainte budgétaire.",
          ],
        },
        {
          h2: "Restitution flexible",
          body: [
            "Vous pouvez restituer la voiture à Timisoara, à Bucarest ou dans une autre ville : une location one-way s'organise facilement sur devis.",
            "Notre équipe reste joignable sur WhatsApp tout au long de votre séjour pour ajuster les modalités si nécessaire.",
          ],
        },
      ],
      faqs: [
        { q: "Peut-on récupérer une voiture à l'aéroport de Timisoara ?", a: "Oui, par livraison depuis Bucarest, organisée sur devis selon vos dates." },
        { q: "Quels documents faut-il pour la prise en charge ?", a: "Permis de conduire valide, pièce d'identité et confirmation de réservation." },
        { q: "L'assurance couvre-t-elle toute la Roumanie ?", a: "Oui, l'assurance RCA et CASCO est valable sur tout le territoire roumain." },
        { q: "Puis-je restituer le véhicule dans une autre ville ?", a: "Oui, contactez-nous sur WhatsApp pour organiser une restitution one-way." },
      ],
      keywords: "location voiture timisoara, location voiture aeroport timisoara, voiture banat roumanie",
    },

    "airport-sibiu": {
      slug: "location-voiture-aeroport-sibiu",
      title: "Location voiture aéroport Sibiu (SBZ) | carentals.ro",
      description: "Location voiture à l'aéroport de Sibiu. Livraison depuis Bucarest sur devis, sans caution, assurance RCA+CASCO incluse.",
      eyebrow: "Aéroport de Sibiu",
      h1: "Location voiture aéroport de Sibiu (SBZ)",
      intro: "Sibiu est une base idéale pour explorer la Transylvanie et rejoindre le Transfagarasan. carentals.ro peut livrer un véhicule jusqu'à l'aéroport de Sibiu depuis Bucarest, sur devis et sans caution.",
      perks,
      sections: [
        {
          h2: "Location voiture à Sibiu depuis Bucarest",
          body: [
            "Nous livrons des véhicules jusqu'à l'aéroport de Sibiu pour les voyageurs souhaitant démarrer leur road trip directement en Transylvanie.",
            "Le coût de la livraison dépend de la distance et des dates : demandez votre devis gratuit sur WhatsApp avant de réserver.",
          ],
        },
        {
          h2: "Sibiu, point de départ vers le Transfagarasan",
          body: [
            "Depuis Sibiu, la route du Transfagarasan et les paysages des Carpates méridionales sont accessibles en moins de deux heures de route.",
            "Le kilométrage illimité inclus vous permet de multiplier les détours pittoresques sans surcoût.",
          ],
        },
        {
          h2: "Mêmes conditions qu'à Bucarest",
          body: [
            "Assurance RCA et CASCO, vignette et absence de caution s'appliquent aussi aux véhicules livrés à Sibiu.",
            "Le paiement se fait par carte de débit, espèces ou virement, comme pour toute location carentals.ro.",
          ],
        },
      ],
      faqs: [
        { q: "Livrez-vous des voitures à l'aéroport de Sibiu ?", a: "Oui, sur devis, depuis notre agence de Bucarest." },
        { q: "Peut-on rejoindre le Transfagarasan depuis Sibiu ?", a: "Oui, c'est l'un des accès les plus rapides à cette route mythique." },
        { q: "Faut-il une carte de crédit pour la livraison à Sibiu ?", a: "Non, aucune carte de crédit ni caution n'est requise." },
        { q: "Le devis inclut-il le retour du véhicule ?", a: "Oui, la restitution est incluse dans le devis, à Sibiu ou ailleurs sur demande." },
      ],
      keywords: "location voiture sibiu, location voiture aeroport sibiu, voiture transfagarasan",
    },

    "city-bucharest": {
      slug: "location-voiture-bucarest",
      title: "Location voiture Bucarest dès 35€/jour | carentals.ro",
      description: "Location voiture à Bucarest, agence centrale et aéroport Otopeni. Sans caution, assurance et vignette incluses, dès 35€/jour.",
      eyebrow: "Location voiture à Bucarest",
      h1: "Location voiture Bucarest : agence centrale et aéroport",
      intro: "carentals.ro loue des voitures à Bucarest depuis son agence du Boulevard Regina Elisabeta 33, en plein centre-ville, ainsi qu'à l'aéroport Otopeni. Une flotte de 28 véhicules vous attend, sans caution ni carte de crédit.",
      perks,
      sections: [
        {
          h2: "Une agence en plein centre de Bucarest",
          body: [
            "Notre agence, située Boulevard Regina Elisabeta 33, est facilement accessible à pied depuis le centre historique et les principaux hôtels de Bucarest.",
            "La prise en charge y est gratuite, tout comme à l'aéroport Otopeni ; toute autre adresse dans Bucarest est desservie moyennant 20 € de livraison.",
          ],
        },
        {
          h2: "Se déplacer facilement dans la capitale",
          body: [
            "Une voiture de location permet de rejoindre facilement les quartiers excentrés de Bucarest, mais aussi de partir en excursion d'une journée vers Brasov, Sinaia ou le Danube.",
            "Le stationnement dans le centre peut être limité : nous vous conseillons volontiers les meilleures options selon votre itinéraire.",
          ],
        },
        {
          h2: "Réserver rapidement via WhatsApp",
          body: [
            "La réservation se fait en quelques messages sur WhatsApp au +40738792499 : indiquez vos dates, le nombre de passagers et le type de véhicule souhaité.",
            "Notre équipe vous confirme la disponibilité et le tarif en quelques minutes, sans engagement ni frais cachés.",
          ],
        },
      ],
      faqs: [
        { q: "Où se trouve l'agence carentals.ro à Bucarest ?", a: "Au Boulevard Regina Elisabeta 33, en plein centre de Bucarest." },
        { q: "Livrez-vous la voiture à mon hôtel à Bucarest ?", a: "Oui, la livraison à toute adresse à Bucarest coûte 20 €." },
        { q: "Quel est le tarif minimum de location ?", a: "Les prix débutent à 35 €/jour, assurance et kilométrage illimité inclus." },
        { q: "Puis-je payer en espèces à Bucarest ?", a: "Oui, en euros ou en lei roumains, ainsi que par carte de débit ou virement." },
      ],
      keywords: "location voiture bucarest, location voiture centre bucarest, agence location voiture bucarest",
    },

    "city-brasov": {
      slug: "location-voiture-brasov",
      title: "Location voiture Brasov | carentals.ro",
      description: "Location voiture à Brasov, livraison depuis Bucarest sur devis. Sans caution, assurance RCA+CASCO et vignette incluses.",
      eyebrow: "Location voiture à Brasov",
      h1: "Location voiture Brasov : porte d'entrée des Carpates",
      intro: "Brasov, avec ses ruelles médiévales et sa proximité avec le château de Bran, mérite d'être explorée en voiture. carentals.ro livre des véhicules depuis Bucarest jusqu'à Brasov, sur devis et sans caution.",
      perks,
      sections: [
        {
          h2: "Louer une voiture à Brasov",
          body: [
            "Brasov se trouve à environ deux heures de route de Bucarest ; nous organisons la livraison du véhicule directement en ville ou à votre hôtel, sur devis personnalisé.",
            "Cette solution est idéale pour les voyageurs souhaitant combiner un séjour urbain à Bucarest avec une excursion en Transylvanie.",
          ],
        },
        {
          h2: "Explorer les environs de Brasov",
          body: [
            "Depuis Brasov, le château de Bran, la citadelle de Rasnov et les stations de montagne comme Poiana Brasov sont accessibles en moins d'une heure.",
            "Le kilométrage illimité vous permet d'enchaîner les visites sans surveiller votre compteur.",
          ],
        },
        {
          h2: "Livraison et restitution flexibles",
          body: [
            "Vous pouvez récupérer la voiture à Brasov et la restituer à Bucarest, à l'aéroport Otopeni ou ailleurs, moyennant un devis one-way.",
            "Contactez-nous sur WhatsApp pour connaître les délais et coûts de livraison selon votre date d'arrivée.",
          ],
        },
      ],
      faqs: [
        { q: "Peut-on louer une voiture directement à Brasov ?", a: "Le véhicule est livré depuis Bucarest sur devis, directement à Brasov." },
        { q: "Combien coûte la livraison à Brasov ?", a: "Le tarif dépend de la distance et de la date, demandez un devis sur WhatsApp." },
        { q: "Le château de Bran est-il facilement accessible ?", a: "Oui, à environ 30 minutes de route de Brasov." },
        { q: "Puis-je restituer la voiture ailleurs qu'à Brasov ?", a: "Oui, une restitution one-way est possible sur devis." },
      ],
      keywords: "location voiture brasov, voiture brasov chateau bran, location voiture transylvanie",
    },

    "city-cluj": {
      slug: "location-voiture-cluj-napoca",
      title: "Location voiture Cluj-Napoca | carentals.ro",
      description: "Location voiture à Cluj-Napoca, livraison depuis Bucarest sur devis. Sans caution, assurance et vignette incluses.",
      eyebrow: "Location voiture à Cluj-Napoca",
      h1: "Location voiture Cluj-Napoca",
      intro: "Cluj-Napoca, capitale de la Transylvanie, est un excellent point de départ pour explorer le centre du pays. carentals.ro y livre des véhicules depuis Bucarest, sur devis, avec les mêmes conditions sans caution.",
      perks,
      sections: [
        {
          h2: "Louer une voiture à Cluj-Napoca",
          body: [
            "Bien que notre flotte soit basée à Bucarest, nous livrons régulièrement des véhicules à Cluj-Napoca pour les voyageurs et professionnels en déplacement.",
            "Un devis clair, incluant le coût de la livraison, vous est envoyé sur WhatsApp avant toute confirmation.",
          ],
        },
        {
          h2: "Une ville dynamique à explorer en voiture",
          body: [
            "Cluj-Napoca est entourée de paysages vallonnés et de villages traditionnels, idéaux pour des excursions d'une journée.",
            "Avec le kilométrage illimité inclus, vous pouvez explorer la région sans limite de distance.",
          ],
        },
        {
          h2: "Options de restitution",
          body: [
            "La restitution peut se faire à Cluj-Napoca même, à Bucarest, ou dans une autre ville roumaine sur devis one-way.",
            "Notre équipe reste disponible sur WhatsApp pendant toute la durée de la location pour tout ajustement.",
          ],
        },
      ],
      faqs: [
        { q: "Livrez-vous des voitures à Cluj-Napoca ?", a: "Oui, depuis Bucarest, sur devis selon vos dates." },
        { q: "Le prix inclut-il l'assurance à Cluj ?", a: "Oui, RCA, CASCO, vignette et kilométrage illimité sont toujours inclus." },
        { q: "Peut-on restituer la voiture à Bucarest après un séjour à Cluj ?", a: "Oui, une restitution one-way est possible sur devis." },
        { q: "Quel délai de réservation conseillez-vous ?", a: "Au moins une semaine à l'avance pour organiser la livraison." },
      ],
      keywords: "location voiture cluj napoca, voiture cluj transylvanie, location voiture cluj",
    },

    "city-constanta": {
      slug: "location-voiture-constanta",
      title: "Location voiture Constanta | carentals.ro",
      description: "Location voiture à Constanta et sur le littoral mer Noire, livraison depuis Bucarest sur devis. Sans caution, assurance incluse.",
      eyebrow: "Location voiture à Constanta",
      h1: "Location voiture Constanta et littoral mer Noire",
      intro: "Constanta et les plages de la mer Noire se découvrent facilement en voiture. carentals.ro organise la livraison d'un véhicule depuis Bucarest jusqu'à Constanta, sur devis et sans caution.",
      perks,
      sections: [
        {
          h2: "Louer une voiture pour la côte roumaine",
          body: [
            "Constanta et les stations balnéaires voisines comme Mamaia ou Vama Veche sont à environ trois heures de route de Bucarest.",
            "Nous livrons des véhicules directement à Constanta sur devis, pratique pour les vacanciers qui ne souhaitent pas conduire depuis la capitale.",
          ],
        },
        {
          h2: "Explorer le littoral en toute liberté",
          body: [
            "Une voiture de location permet de passer facilement d'une plage à l'autre, de Mamaia à Vama Veche, ou de visiter le delta du Danube tout proche.",
            "Le kilométrage illimité inclus est particulièrement utile pour ce type de road trip côtier.",
          ],
        },
        {
          h2: "Livraison et restitution sur devis",
          body: [
            "Le coût de la livraison jusqu'à Constanta dépend de la saison et de la date : contactez-nous sur WhatsApp pour un devis rapide.",
            "Une restitution à Bucarest, à l'aéroport Otopeni ou ailleurs peut également être organisée en location one-way.",
          ],
        },
      ],
      faqs: [
        { q: "Peut-on louer une voiture directement à Constanta ?", a: "Le véhicule est livré depuis Bucarest sur devis, jusqu'à Constanta." },
        { q: "L'assurance couvre-t-elle la route côtière ?", a: "Oui, l'assurance RCA et CASCO couvre tout le territoire roumain, y compris la côte." },
        { q: "Combien de temps à l'avance réserver en été ?", a: "Nous recommandons de réserver au moins deux semaines à l'avance en haute saison." },
        { q: "Puis-je restituer la voiture à Bucarest après mon séjour à la mer ?", a: "Oui, une restitution one-way est possible sur devis." },
      ],
      keywords: "location voiture constanta, location voiture mer noire roumanie, voiture mamaia",
    },

    cheap: {
      slug: "location-voiture-pas-cher-roumanie",
      title: "Location voiture pas cher Roumanie dès 35€ | carentals.ro",
      description: "Location voiture pas cher en Roumanie dès 35€/jour, sans caution, assurance et vignette incluses. Réservez via WhatsApp.",
      eyebrow: "Location voiture économique",
      h1: "Location voiture pas cher en Roumanie",
      intro: "Voyager en Roumanie ne doit pas coûter cher. carentals.ro propose des locations dès 35 €/jour, assurance complète et vignette incluses, sans caution ni frais cachés.",
      perks,
      sections: [
        {
          h2: "Des tarifs transparents dès 35€/jour",
          body: [
            "Nos tarifs affichés incluent toujours l'assurance RCA et CASCO, la vignette roumaine et le kilométrage illimité : aucune surprise à la restitution du véhicule.",
            "Avec 28 véhicules en flotte, des citadines économiques aux modèles familiaux, il existe une option adaptée à chaque budget.",
          ],
        },
        {
          h2: "Économiser sans compromis sur la sécurité",
          body: [
            "Louer pas cher ne signifie pas renoncer à la sécurité : chaque véhicule est entretenu régulièrement et couvert par une assurance complète.",
            "L'absence de caution permet aussi d'économiser sur les frais bancaires liés au blocage temporaire de fonds pratiqué par d'autres loueurs.",
          ],
        },
        {
          h2: "Conseils pour réduire encore la facture",
          body: [
            "Réserver à l'avance et éviter les périodes de très haute saison permet souvent d'obtenir de meilleurs tarifs journaliers.",
            "Récupérer le véhicule à notre agence de Bucarest ou à l'aéroport Otopeni, tous deux gratuits, permet aussi d'éviter les frais de livraison.",
          ],
        },
      ],
      faqs: [
        { q: "Quel est le tarif le plus bas proposé ?", a: "Nos locations débutent à 35 €/jour, assurance et kilométrage illimité inclus." },
        { q: "Y a-t-il des frais cachés ?", a: "Non, tous nos tarifs incluent assurance, vignette et kilométrage illimité." },
        { q: "La caution augmente-t-elle le coût réel ?", a: "Chez carentals.ro, il n'y a aucune caution à bloquer, ce qui simplifie le budget de voyage." },
        { q: "Comment obtenir le meilleur prix ?", a: "Réservez à l'avance et récupérez le véhicule à l'agence ou à l'aéroport pour éviter les frais de livraison." },
      ],
      keywords: "location voiture pas cher roumanie, location voiture economique roumanie, louer voiture bucarest pas cher",
    },

    automatic: {
      slug: "location-voiture-automatique-roumanie",
      title: "Location voiture automatique Roumanie | carentals.ro",
      description: "Location voiture avec boîte automatique en Roumanie, sans caution, assurance incluse, dès 35€/jour. Réservez via WhatsApp.",
      eyebrow: "Boîte automatique",
      h1: "Location voiture automatique en Roumanie",
      intro: "Pour un confort de conduite maximal, notamment sur les routes de montagne des Carpates, carentals.ro propose des véhicules à boîte automatique disponibles à Bucarest et à l'aéroport Otopeni.",
      perks,
      sections: [
        {
          h2: "Pourquoi choisir une boîte automatique en Roumanie",
          body: [
            "Les routes de montagne comme le Transfagarasan ou le Transalpina comportent de nombreux virages : une boîte automatique réduit la fatigue de conduite sur ces trajets.",
            "Pour les conducteurs peu habitués à la conduite en pays étranger, l'automatique simplifie également la circulation dans les grandes villes comme Bucarest.",
          ],
        },
        {
          h2: "Disponibilité et réservation",
          body: [
            "Notre flotte comprend plusieurs modèles à boîte automatique ; nous recommandons de préciser cette préférence dès la prise de contact sur WhatsApp pour garantir la disponibilité.",
            "Comme pour toutes nos locations, ces véhicules incluent assurance RCA/CASCO, vignette et kilométrage illimité, sans caution.",
          ],
        },
        {
          h2: "Conseils pour la route",
          body: [
            "Sur les routes de montagne, pensez à vérifier la météo avant le départ, surtout entre novembre et avril.",
            "Notre équipe peut vous conseiller sur les meilleurs itinéraires selon la saison et le type de véhicule loué.",
          ],
        },
      ],
      faqs: [
        { q: "Proposez-vous des voitures automatiques ?", a: "Oui, plusieurs modèles à boîte automatique sont disponibles dans notre flotte de 28 véhicules." },
        { q: "Faut-il réserver la boîte automatique à l'avance ?", a: "Oui, nous recommandons de préciser cette préférence dès la réservation pour garantir la disponibilité." },
        { q: "Le tarif est-il plus élevé pour une automatique ?", a: "Le tarif dépend du modèle choisi ; contactez-nous sur WhatsApp pour un devis précis." },
        { q: "L'automatique est-elle adaptée au Transfagarasan ?", a: "Oui, elle est particulièrement recommandée pour ce type de route sinueuse." },
      ],
      keywords: "location voiture automatique roumanie, voiture boite automatique bucarest, location automatique bucarest",
    },

    "unlimited-km": {
      slug: "location-voiture-kilometrage-illimite-roumanie",
      title: "Location voiture kilométrage illimité Roumanie | carentals.ro",
      description: "Location voiture avec kilométrage illimité inclus en Roumanie, sans caution, assurance complète. Dès 35€/jour, réservez via WhatsApp.",
      eyebrow: "Kilométrage illimité inclus",
      h1: "Location voiture avec kilométrage illimité en Roumanie",
      intro: "Toutes nos locations incluent le kilométrage illimité, sans exception : parcourez la Roumanie d'un bout à l'autre sans jamais surveiller votre compteur ni craindre de frais supplémentaires.",
      perks,
      sections: [
        {
          h2: "Pourquoi le kilométrage illimité change tout",
          body: [
            "Contrairement à d'autres loueurs qui facturent chaque kilomètre au-delà d'un forfait, carentals.ro inclut systématiquement le kilométrage illimité, quelle que soit la durée de location.",
            "Cela permet de planifier de longs road trips, entre Bucarest, les Carpates et la mer Noire, sans calculer les distances à l'avance.",
          ],
        },
        {
          h2: "Idéal pour les road trips en Roumanie",
          body: [
            "La Roumanie regorge de destinations éloignées les unes des autres : Transfagarasan, Transylvanie, delta du Danube ou littoral de la mer Noire.",
            "Avec le kilométrage illimité, ces itinéraires deviennent accessibles sans surcoût, même pour un séjour d'une à deux semaines.",
          ],
        },
        {
          h2: "Ce qui est inclus en plus",
          body: [
            "En plus du kilométrage illimité, chaque location comprend l'assurance RCA et CASCO ainsi que la vignette roumaine obligatoire.",
            "Aucune caution n'est exigée, ce qui simplifie encore la planification budgétaire de votre voyage.",
          ],
        },
      ],
      faqs: [
        { q: "Le kilométrage illimité est-il vraiment sans limite ?", a: "Oui, aucune limite de distance n'est appliquée, quelle que soit la durée de location." },
        { q: "Cela s'applique-t-il à tous les véhicules ?", a: "Oui, tous les véhicules de notre flotte de 28 voitures incluent le kilométrage illimité." },
        { q: "Y a-t-il des frais si je parcours beaucoup de kilomètres ?", a: "Non, aucun frais supplémentaire n'est facturé quel que soit le kilométrage parcouru." },
        { q: "Le kilométrage illimité est-il valable hors de Roumanie ?", a: "Contactez-nous sur WhatsApp pour connaître les conditions de sortie du territoire." },
      ],
      keywords: "location voiture kilometrage illimite roumanie, voiture kilometrage illimite bucarest, road trip roumanie voiture",
    },

    "one-way": {
      slug: "location-voiture-aller-simple-roumanie",
      title: "Location voiture aller simple (one-way) Roumanie | carentals.ro",
      description: "Location voiture one-way en Roumanie : récupérez à Bucarest ou Otopeni, restituez ailleurs sur devis. Sans caution, assurance incluse.",
      eyebrow: "Location aller simple",
      h1: "Location voiture aller simple (one-way) en Roumanie",
      intro: "Vous souhaitez récupérer votre voiture à Bucarest et la restituer ailleurs en Roumanie ? carentals.ro propose des locations one-way, avec devis personnalisé selon la ville de restitution.",
      perks,
      sections: [
        {
          h2: "Comment fonctionne la location one-way",
          body: [
            "Une location aller simple vous permet de prendre le véhicule dans une ville et de le rendre dans une autre, sans revenir sur vos pas, idéal pour un road trip linéaire à travers la Roumanie.",
            "Ce service s'organise sur devis, en fonction de la distance entre les deux villes et de la disponibilité de notre équipe pour récupérer le véhicule.",
          ],
        },
        {
          h2: "Exemples d'itinéraires possibles",
          body: [
            "Un itinéraire classique consiste à prendre la voiture à Bucarest ou à l'aéroport Otopeni, puis à la restituer à Brasov, Sibiu ou Cluj après un circuit en Transylvanie.",
            "Il est également possible de terminer un séjour sur le littoral en restituant le véhicule à Constanta, plutôt que de revenir jusqu'à Bucarest.",
          ],
        },
        {
          h2: "Réserver une location one-way",
          body: [
            "Contactez-nous sur WhatsApp avec votre ville de départ, votre ville de restitution et vos dates : nous vous envoyons un devis clair incluant d'éventuels frais de repositionnement.",
            "Comme pour toutes nos locations, assurance, vignette et kilométrage illimité restent inclus, sans caution à verser.",
          ],
        },
      ],
      faqs: [
        { q: "Peut-on rendre la voiture dans une autre ville que Bucarest ?", a: "Oui, une restitution one-way est possible sur devis, dans plusieurs villes roumaines." },
        { q: "Y a-t-il un supplément pour une location one-way ?", a: "Un supplément peut s'appliquer selon la distance, précisé dans le devis avant réservation." },
        { q: "Le kilométrage illimité s'applique-t-il aux locations one-way ?", a: "Oui, le kilométrage illimité est toujours inclus." },
        { q: "Comment obtenir un devis one-way ?", a: "Écrivez-nous sur WhatsApp avec vos villes de départ et d'arrivée." },
      ],
      keywords: "location voiture aller simple roumanie, location voiture one-way roumanie, voiture retour ville differente",
    },

    "seven-seater": {
      slug: "location-voiture-7-places-roumanie",
      title: "Location voiture 7 places Roumanie | carentals.ro",
      description: "Location de monospace 7 places en Roumanie, idéal familles et groupes. Sans caution, assurance incluse, dès 35€/jour.",
      eyebrow: "Monospace 7 places",
      h1: "Location voiture 7 places en Roumanie",
      intro: "Pour voyager en famille nombreuse ou entre amis, carentals.ro propose des monospaces 7 places dans sa flotte de 28 véhicules, avec assurance complète et sans caution.",
      perks: [
        { title: "Idéal pour les groupes", text: "Jusqu'à 7 passagers et leurs bagages voyagent confortablement dans nos monospaces." },
        { title: "Coffre spacieux", text: "Un espace de rangement généreux, parfait pour les valises et le matériel de voyage." },
        { title: "Assurance et vignette incluses", text: "Comme tous nos véhicules, les 7 places incluent RCA, CASCO, vignette et kilométrage illimité." },
        { title: "Réservation anticipée conseillée", text: "Les monospaces étant très demandés, réservez tôt via WhatsApp pour garantir la disponibilité." },
      ],
      sections: [
        {
          h2: "Un véhicule adapté aux familles et groupes",
          body: [
            "Voyager à plusieurs en Roumanie, que ce soit en famille ou entre amis, est bien plus simple avec un monospace 7 places offrant assez d'espace pour tous les passagers et les bagages.",
            "Nos modèles 7 places sont entretenus régulièrement et couverts par l'assurance RCA et CASCO, comme le reste de notre flotte.",
          ],
        },
        {
          h2: "Disponibilité et réservation",
          body: [
            "Les véhicules 7 places étant limités dans notre flotte de 28 voitures, nous recommandons de réserver plusieurs semaines à l'avance, surtout en haute saison estivale.",
            "La prise en charge reste gratuite à notre agence de Bucarest ou à l'aéroport Otopeni, comme pour tous nos véhicules.",
          ],
        },
        {
          h2: "Voyager confortablement en Roumanie",
          body: [
            "Un monospace 7 places est particulièrement adapté pour un road trip vers les Carpates ou le littoral de la mer Noire avec toute la famille.",
            "Le kilométrage illimité inclus permet de multiplier les étapes sans se soucier des distances parcourues.",
          ],
        },
      ],
      faqs: [
        { q: "Combien de personnes peuvent voyager dans un monospace ?", a: "Jusqu'à 7 passagers, bagages inclus selon le modèle." },
        { q: "Faut-il réserver longtemps à l'avance ?", a: "Oui, nous recommandons plusieurs semaines à l'avance, surtout en été." },
        { q: "Le tarif d'un 7 places est-il plus élevé ?", a: "Le tarif dépend du modèle exact ; contactez-nous sur WhatsApp pour un devis." },
        { q: "L'assurance est-elle la même que pour les autres véhicules ?", a: "Oui, RCA, CASCO, vignette et kilométrage illimité sont toujours inclus." },
      ],
      keywords: "location voiture 7 places roumanie, monospace location bucarest, voiture familiale roumanie",
    },

    "guide-transfagarasan": {
      slug: "guide-route-transfagarasan-voiture",
      title: "Guide Transfagarasan en voiture de location | carentals.ro",
      description: "Guide pratique pour parcourir le Transfagarasan en voiture de location : meilleure saison, conseils de conduite, points d'intérêt.",
      eyebrow: "Guide de voyage",
      h1: "Parcourir le Transfagarasan en voiture de location",
      intro: "Le Transfagarasan, surnommée l'une des plus belles routes du monde, se découvre idéalement au volant d'une voiture de location. Voici nos conseils pratiques pour préparer ce road trip depuis Bucarest.",
      perks: [
        { title: "Véhicule adapté à la montagne", text: "Nous conseillons volontiers un modèle robuste ou une boîte automatique pour ce type de route." },
        { title: "Assurance montagne incluse", text: "RCA et CASCO couvrent votre trajet sur toute la route du Transfagarasan." },
        { title: "Kilométrage illimité", text: "Faites des détours et arrêts photo sans vous soucier des kilomètres parcourus." },
        { title: "Conseils d'itinéraire personnalisés", text: "Notre équipe vous indique les meilleures périodes et étapes selon la météo." },
      ],
      sections: [
        {
          h2: "Quand partir sur le Transfagarasan",
          body: [
            "La route du Transfagarasan est généralement ouverte de fin juin à fin octobre, selon les conditions météorologiques ; en dehors de cette période, elle est souvent fermée par la neige.",
            "Avant le départ depuis Bucarest, il est toujours utile de vérifier l'état de la route, car elle peut fermer temporairement en cas de mauvais temps même en été.",
          ],
        },
        {
          h2: "Préparer son itinéraire depuis Bucarest",
          body: [
            "Comptez environ trois heures de route entre Bucarest et le début du Transfagarasan, en passant par la région de l'Argeș.",
            "Louer une voiture avec assurance complète et kilométrage illimité, comme chez carentals.ro, permet d'aborder sereinement ce trajet exigeant, avec de nombreux virages en épingle.",
          ],
        },
        {
          h2: "Étapes incontournables sur la route",
          body: [
            "Le lac glaciaire de Balea et le barrage de Vidraru comptent parmi les arrêts les plus spectaculaires sur cette route de montagne.",
            "Prévoyez une journée complète pour profiter pleinement du trajet, avec des arrêts photo réguliers et une pause déjeuner en altitude.",
          ],
        },
      ],
      faqs: [
        { q: "Quelle est la meilleure saison pour le Transfagarasan ?", a: "De fin juin à fin octobre, selon les conditions météorologiques." },
        { q: "Faut-il un véhicule spécial pour cette route ?", a: "Une voiture standard convient, mais une boîte automatique facilite la conduite dans les virages." },
        { q: "Combien de temps prévoir pour l'excursion ?", a: "Une journée complète est recommandée pour profiter des arrêts en chemin." },
        { q: "L'assurance couvre-t-elle cette route de montagne ?", a: "Oui, notre assurance RCA et CASCO couvre l'ensemble du territoire roumain." },
      ],
      keywords: "transfagarasan voiture location, route transfagarasan roumanie, road trip transfagarasan",
    },

    "guide-transylvania": {
      slug: "guide-transylvanie-voiture-location",
      title: "Guide Transylvanie en voiture de location | carentals.ro",
      description: "Guide pratique pour explorer la Transylvanie en voiture de location depuis Bucarest : châteaux, villages saxons, conseils d'itinéraire.",
      eyebrow: "Guide de voyage",
      h1: "Explorer la Transylvanie en voiture de location",
      intro: "Châteaux médiévaux, villages saxons fortifiés et paysages de collines : la Transylvanie se découvre idéalement en voiture. Voici un guide pratique pour organiser votre road trip depuis Bucarest.",
      perks,
      sections: [
        {
          h2: "Pourquoi visiter la Transylvanie en voiture",
          body: [
            "Les villes et villages de Transylvanie, comme Brasov, Sighisoara ou Sibiu, sont dispersés sur un vaste territoire vallonné, mal desservi par les transports en commun réguliers.",
            "Une voiture de location permet de composer un itinéraire sur mesure, en s'arrêtant dans les villages saxons et les points de vue selon vos envies.",
          ],
        },
        {
          h2: "Itinéraire suggéré depuis Bucarest",
          body: [
            "Un itinéraire classique relie Bucarest à Brasov, puis Sighisoara, Sibiu et retour, sur environ cinq à sept jours en incluant les visites.",
            "Le kilométrage illimité inclus dans nos locations permet d'ajouter facilement des détours vers des villages moins connus.",
          ],
        },
        {
          h2: "Conseils pratiques pour la route",
          body: [
            "Les routes secondaires en Transylvanie sont parfois étroites et sinueuses ; une conduite prudente est recommandée, surtout la nuit.",
            "Pensez à la vignette roumaine, incluse dans nos locations, obligatoire sur les routes nationales et autoroutes du pays.",
          ],
        },
      ],
      faqs: [
        { q: "Combien de jours prévoir pour la Transylvanie ?", a: "Entre cinq et sept jours pour découvrir les principales villes et villages." },
        { q: "Peut-on louer la voiture à Bucarest et la rendre en Transylvanie ?", a: "Oui, une restitution one-way est possible sur devis." },
        { q: "La vignette est-elle incluse ?", a: "Oui, la vignette roumaine est toujours incluse dans nos locations." },
        { q: "Quels villages saxons ne pas manquer ?", a: "Biertan, Viscri et Sighisoara comptent parmi les incontournables." },
      ],
      keywords: "voiture location transylvanie, road trip transylvanie roumanie, location voiture chateau bran",
    },

    "guide-black-sea": {
      slug: "guide-mer-noire-voiture-location",
      title: "Guide mer Noire en voiture de location | carentals.ro",
      description: "Guide pratique pour explorer le littoral de la mer Noire en voiture de location depuis Bucarest : plages, delta du Danube, conseils.",
      eyebrow: "Guide de voyage",
      h1: "Explorer le littoral de la mer Noire en voiture de location",
      intro: "Le littoral roumain de la mer Noire, entre Constanta, Mamaia et Vama Veche, se découvre facilement en voiture. Voici nos conseils pour organiser ce road trip depuis Bucarest.",
      perks,
      sections: [
        {
          h2: "Pourquoi louer une voiture pour la mer Noire",
          body: [
            "Le littoral roumain s'étend sur plus de 200 kilomètres, entre stations balnéaires animées et plages plus sauvages au sud, difficiles à relier sans véhicule personnel.",
            "Une voiture de location permet aussi de visiter le delta du Danube tout proche, réserve naturelle classée à l'UNESCO.",
          ],
        },
        {
          h2: "Itinéraire suggéré depuis Bucarest",
          body: [
            "Comptez environ trois heures de route entre Bucarest et Constanta, via l'autoroute A2, une des mieux entretenues du pays.",
            "Depuis Constanta, Mamaia se trouve à quelques minutes seulement, tandis que Vama Veche, plus au sud, demande environ une heure supplémentaire.",
          ],
        },
        {
          h2: "Conseils pratiques pour l'été",
          body: [
            "En haute saison estivale, la circulation peut être dense sur l'autoroute A2 le week-end : privilégiez un départ tôt le matin ou en semaine.",
            "Le stationnement près des plages les plus prisées peut être limité ; certaines stations proposent des parkings payants à proximité.",
          ],
        },
      ],
      faqs: [
        { q: "Combien de temps de route entre Bucarest et Constanta ?", a: "Environ trois heures via l'autoroute A2." },
        { q: "Peut-on visiter le delta du Danube en voiture ?", a: "Oui, en partie, avant de poursuivre en bateau pour les zones les plus reculées." },
        { q: "Quelle est la meilleure période pour la mer Noire ?", a: "De juin à septembre pour profiter pleinement des plages." },
        { q: "Le trajet est-il inclus dans le kilométrage illimité ?", a: "Oui, le kilométrage illimité couvre l'ensemble du trajet, sans restriction." },
      ],
      keywords: "voiture location mer noire roumanie, road trip constanta mamaia, location voiture littoral roumanie",
    },

    "rules-rovinieta": {
      slug: "vignette-rovinieta-roumanie-voiture-location",
      title: "Vignette Rovinieta Roumanie : guide voiture location | carentals.ro",
      description: "Tout savoir sur la vignette roumaine (rovinieta) : obligation, tarifs, et pourquoi elle est incluse dans nos locations de voiture.",
      eyebrow: "Règles de conduite en Roumanie",
      h1: "La vignette roumaine (rovinieta) : ce qu'il faut savoir",
      intro: "La rovinieta est une vignette électronique obligatoire pour circuler sur les routes nationales et autoroutes roumaines. Chez carentals.ro, elle est systématiquement incluse dans le prix de la location.",
      perks: [
        { title: "Vignette toujours incluse", text: "Aucune démarche à faire : la rovinieta est déjà réglée pour la durée de votre location." },
        { title: "Zéro amende surprise", text: "Roulez en toute légalité sur les routes nationales et autoroutes roumaines." },
        { title: "Valable sur tout le pays", text: "La vignette couvre l'ensemble du réseau routier principal roumain." },
        { title: "Assistance en cas de doute", text: "Notre équipe répond à toutes vos questions sur WhatsApp." },
      ],
      sections: [
        {
          h2: "Qu'est-ce que la rovinieta ?",
          body: [
            "La rovinieta est une vignette électronique liée à la plaque d'immatriculation du véhicule, obligatoire pour circuler sur la majorité des routes nationales et autoroutes de Roumanie.",
            "Son absence peut entraîner une amende, contrôlée automatiquement par des caméras placées le long des grands axes routiers.",
          ],
        },
        {
          h2: "Pourquoi elle est incluse chez carentals.ro",
          body: [
            "Pour éviter toute mauvaise surprise, la rovinieta est systématiquement incluse dans le prix de nos locations, quelle que soit la durée du séjour.",
            "Vous n'avez donc aucune démarche administrative à effectuer avant de prendre la route.",
          ],
        },
        {
          h2: "Sur quelles routes est-elle obligatoire ?",
          body: [
            "La vignette est requise sur la plupart des routes nationales et autoroutes, mais pas nécessairement dans les centres-villes.",
            "En cas de doute sur un trajet précis, notre équipe peut vous renseigner directement sur WhatsApp avant votre départ.",
          ],
        },
      ],
      faqs: [
        { q: "La vignette est-elle vraiment incluse dans le prix ?", a: "Oui, systématiquement, pour toute la durée de votre location." },
        { q: "Que se passe-t-il en cas d'absence de vignette ?", a: "Une amende peut être appliquée, détectée par des caméras automatiques sur les grands axes." },
        { q: "La vignette couvre-t-elle tout le pays ?", a: "Elle couvre la majorité des routes nationales et autoroutes roumaines." },
        { q: "Dois-je faire une démarche avant de partir ?", a: "Non, tout est déjà réglé lors de la remise du véhicule." },
      ],
      keywords: "rovinieta roumanie, vignette roumanie voiture, vignette autoroute roumanie",
    },

    "rules-winter-tires": {
      slug: "pneus-hiver-roumanie-voiture-location",
      title: "Pneus hiver en Roumanie : règles et conseils | carentals.ro",
      description: "Réglementation sur les pneus hiver en Roumanie et conseils pour louer une voiture équipée en toute sécurité en hiver.",
      eyebrow: "Règles de conduite en Roumanie",
      h1: "Pneus hiver en Roumanie : ce qu'il faut savoir",
      intro: "Entre novembre et mars, les conditions hivernales en Roumanie, notamment dans les Carpates, nécessitent une attention particulière aux équipements du véhicule. Voici les règles en vigueur et nos conseils.",
      perks,
      sections: [
        {
          h2: "La réglementation sur les pneus hiver",
          body: [
            "En Roumanie, les véhicules doivent être équipés de pneus adaptés (hiver ou toutes saisons avec le marquage approprié) en cas de conditions hivernales, généralement de novembre à mars.",
            "Cette obligation vise à garantir la sécurité sur les routes de montagne, où le verglas et la neige sont fréquents en hiver.",
          ],
        },
        {
          h2: "Nos véhicules en hiver",
          body: [
            "Pendant la saison hivernale, nos véhicules sont équipés conformément à la réglementation en vigueur, pour circuler en toute sécurité y compris vers les zones montagneuses.",
            "Il est toujours utile de nous signaler votre itinéraire prévu, notamment si vous comptez rouler en montagne, afin d'adapter le véhicule proposé.",
          ],
        },
        {
          h2: "Conseils de conduite en hiver",
          body: [
            "Certaines routes de montagne, comme le Transfagarasan, sont totalement fermées en hiver ; renseignez-vous avant de planifier un itinéraire dans les Carpates entre novembre et mai.",
            "En cas de neige, réduisez votre vitesse et gardez une distance de sécurité accrue, surtout sur les routes secondaires moins traitées.",
          ],
        },
      ],
      faqs: [
        { q: "Les pneus hiver sont-ils obligatoires en Roumanie ?", a: "Oui, en cas de conditions hivernales, généralement de novembre à mars." },
        { q: "Vos voitures sont-elles équipées en hiver ?", a: "Oui, nos véhicules sont équipés conformément à la réglementation en saison hivernale." },
        { q: "Le Transfagarasan est-il ouvert en hiver ?", a: "Non, il est généralement fermé de fin octobre à fin juin." },
        { q: "Que faire en cas de neige sur la route ?", a: "Réduisez votre vitesse et contactez-nous sur WhatsApp en cas de doute sur un itinéraire." },
      ],
      keywords: "pneus hiver roumanie, conduite hiver roumanie voiture, location voiture hiver roumanie",
    },

    "rules-speed-cameras": {
      slug: "radars-limitations-vitesse-roumanie-voiture",
      title: "Radars et limitations de vitesse en Roumanie | carentals.ro",
      description: "Limitations de vitesse et radars en Roumanie : ce qu'il faut savoir pour conduire sereinement votre voiture de location.",
      eyebrow: "Règles de conduite en Roumanie",
      h1: "Radars et limitations de vitesse en Roumanie",
      intro: "Comme dans tout pays, respecter les limitations de vitesse en Roumanie évite les amendes et garantit votre sécurité. Voici un résumé des règles à connaître avant de prendre le volant.",
      perks,
      sections: [
        {
          h2: "Les limitations de vitesse en vigueur",
          body: [
            "En Roumanie, la vitesse est généralement limitée à 50 km/h en agglomération, 90 km/h sur route nationale et 130 km/h sur autoroute, sauf indication contraire.",
            "Ces limites peuvent varier localement, notamment près des écoles, des zones de travaux ou des traversées de villages.",
          ],
        },
        {
          h2: "Les radars fixes et mobiles",
          body: [
            "Des radars fixes et des contrôles mobiles sont présents sur l'ensemble du réseau routier roumain, y compris sur les grands axes reliant Bucarest aux autres régions.",
            "Les amendes pour excès de vitesse peuvent être élevées et sont généralement à régler avant la restitution du véhicule ou par la suite auprès des autorités compétentes.",
          ],
        },
        {
          h2: "Conseils pour une conduite sereine",
          body: [
            "Respecter scrupuleusement la signalisation, en particulier à la sortie des villages où les limitations changent souvent brusquement.",
            "En cas de doute sur une amende reçue après votre location, notre équipe reste disponible sur WhatsApp pour vous accompagner dans les démarches.",
          ],
        },
      ],
      faqs: [
        { q: "Quelle est la limite de vitesse en agglomération ?", a: "50 km/h en général, sauf signalisation différente." },
        { q: "Y a-t-il beaucoup de radars en Roumanie ?", a: "Oui, radars fixes et contrôles mobiles sont fréquents sur tout le réseau routier." },
        { q: "Que faire en cas d'amende après restitution du véhicule ?", a: "Contactez-nous sur WhatsApp, nous vous accompagnons dans la démarche." },
        { q: "La limite sur autoroute est-elle la même partout ?", a: "Généralement 130 km/h, sauf signalisation temporaire différente." },
      ],
      keywords: "limitation vitesse roumanie, radars roumanie voiture, regles conduite roumanie",
    },

    "airport-pickup": {
      slug: "guide-prise-en-charge-aeroport-otopeni",
      title: "Guide prise en charge aéroport Otopeni | carentals.ro",
      description: "Guide étape par étape pour récupérer votre voiture de location à l'aéroport Otopeni de Bucarest, sans stress ni caution.",
      eyebrow: "Guide pratique",
      h1: "Comment récupérer votre voiture à l'aéroport Otopeni",
      intro: "Voici le déroulé exact de la prise en charge de votre véhicule à l'aéroport Henri Coanda (Otopeni), pour un départ sans stress dès votre arrivée à Bucarest.",
      perks: [
        { title: "Point de rendez-vous précis", text: "Les coordonnées exactes vous sont envoyées par WhatsApp avant votre vol." },
        { title: "Aucune caution bloquée", text: "Le paiement se fait sur place, sans blocage de fonds sur votre carte." },
        { title: "Contrat rapide à signer", text: "La vérification du véhicule et la signature du contrat prennent quelques minutes." },
        { title: "Assistance en cas de retard de vol", text: "Prévenez-nous par WhatsApp en cas de retard, nous nous adaptons à votre horaire réel." },
      ],
      sections: [
        {
          h2: "Étape 1 : avant l'atterrissage",
          body: [
            "Dès que vous connaissez votre numéro de vol, envoyez-le nous sur WhatsApp au +40738792499 afin que nous puissions suivre votre horaire d'arrivée en temps réel.",
            "Cela nous permet d'ajuster notre présence à l'aéroport Otopeni même en cas de léger retard de vol.",
          ],
        },
        {
          h2: "Étape 2 : à votre sortie de l'aéroport",
          body: [
            "Une fois vos bagages récupérés, prévenez-nous à nouveau sur WhatsApp : un membre de notre équipe vous rejoint au point de rendez-vous convenu près des arrivées.",
            "La vérification du véhicule, la présentation du permis de conduire et la signature du contrat se font rapidement, sans caution ni carte de crédit exigée.",
          ],
        },
        {
          h2: "Étape 3 : en route",
          body: [
            "Une fois les formalités terminées, vous prenez la route en direction de Bucarest, à environ 30 minutes de l'aéroport, ou vers votre prochaine destination.",
            "En cas de question durant votre séjour, notre équipe reste joignable 24h/24 sur WhatsApp jusqu'à la restitution du véhicule.",
          ],
        },
      ],
      faqs: [
        { q: "Où exactement récupère-t-on la voiture à Otopeni ?", a: "Au point de rendez-vous indiqué par WhatsApp, proche des arrivées de l'aéroport." },
        { q: "Que faire en cas de retard de vol ?", a: "Prévenez-nous sur WhatsApp, nous adaptons l'heure de prise en charge sans frais supplémentaire." },
        { q: "Combien de temps prennent les formalités ?", a: "Généralement moins de 15 minutes, grâce à un contrat simplifié." },
        { q: "Quels documents dois-je présenter ?", a: "Permis de conduire valide, pièce d'identité et confirmation de réservation." },
      ],
      keywords: "prise en charge aeroport otopeni, recuperer voiture aeroport bucarest, guide location voiture otopeni",
    },
  },
};
